module.exports = __webpack_public_path__ + "static/media/goCardlessIcon.d416ac6d.svg";